// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/frontend/stylesheets/producer_post.sass
// module id = 218
// module chunks = 0